import { createContext } from "react";

const SpeedContext = createContext(undefined as any);

export default SpeedContext;
